<mat-expansion-panel #filterBar class="filter-wrapper">
  <mat-expansion-panel-header>
    <div class="filter-title">
      <mat-icon>filter_alt</mat-icon>
      <h3>{{$Locale.get("filters")}}</h3>
    </div>
    <div class="vertical-line"></div>
    <ng-container *ngIf="(filterService.filtersDisplay | async) as appliedFilters; else noFilters">
      <mat-panel-title>
        {{$Locale.get("filters_applied")}}
      </mat-panel-title>
      <mat-chip-list>
        <mat-chip *ngFor="let filter of appliedFilters" selectable removable (removed)="removeFilter(filter)"
          (click)="filterBar.toggle()" [matTooltip]="displayTooltip(filter.name)" matTooltipPosition="above">
          {{filter.label}}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-list>
    </ng-container>
    <ng-template #noFilters>
      <mat-panel-title>
        No filters applied
      </mat-panel-title>
    </ng-template>

  </mat-expansion-panel-header>
  <div class="filter-form-container">
    <form [formGroup]="filterForm" *ngIf="filters" (submit)="getFilters()">
      <div *ngFor="let field of filters" class="filter-field" [ngClass]="field.width ?? ''">
        <ng-container [ngSwitch]="field.type">
          <mat-form-field *ngSwitchCase="'date'" appearance="fill">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput [formControlName]="field.name" [matDatepicker]="picker" (dateChange)="getFilters()"/>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field *ngSwitchCase="'select'" appearance="fill">
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.name" (selectionChange)="getFilters()">
              <mat-option *ngFor="let option of field.values" [value]="option.value">
                {{option.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngSwitchCase="'multi-select'" appearance="fill">
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.name" multiple>
              <mat-option *ngFor="let option of field.values" [value]="option.value">
                {{option.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngSwitchDefault appearance="fill">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput [formControlName]="field.name" [type]="field.type" />
          </mat-form-field>
        </ng-container>
      </div>
      <div class="buttons-container">
        <button mat-stroked-button class="button" type="submit">Search</button>
        <button mat-stroked-button class="button" (click)="resetFilters()">Clear</button>
      </div>
    </form>
  </div>
</mat-expansion-panel>
<mat-divider></mat-divider>